import "../../../../stylesheets/raffle";
import "../../../../stylesheets/templates/raffle/template-1";
import "../../../../stylesheets/templates/raffle/template-2";
import "../../../../stylesheets/templates/raffle/template-3";
import "../../../../stylesheets/templates/raffle/template-4";
import "../../../../stylesheets/accounts/base";
import "./index";

$(document).ready(function () {
  $(document).on("show.bs.modal", ".modal", function () {
    $(".modal-backdrop").not(":last").remove();
  });

  $(document).on(
    "click",
    '[data-toggle="modal"][href="#volunteer-stats"], [data-toggle="modal"][data-target="#volunteer-stats"]',
    function () {
      $(".modal-backdrop").not(":last").remove();
    }
  );

  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get("volunteer_stats") === "true") {
    $(".volunteer-stats").trigger("click");
  }

  $("#cancel-alert-high-price-button").on("click", function (e) {
    e.preventDefault();
    $("#confirm-alert-high-price-field").val("");
    $("#alert-high-price-form").modal("hide");
    var $desktop = $("#product-quantity-desktop");
    var $mobile = $("#product-quantity-mobile");
    if ($desktop.length) {
      $desktop.val("0");
      $desktop.trigger("change");
    }
    if ($mobile.length) {
      $mobile.val("0");
      $mobile.trigger("change");
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});
